import { defineMessages } from 'react-intl';

const I18N_NAMESPACE = 'Blog';

export default defineMessages({
  blogTitle: {
    id: `${I18N_NAMESPACE}.blogTitle`,
    defaultMessage: 'The Otovo Blog',
  },
  blogDescription: {
    id: `${I18N_NAMESPACE}.blogDescription`,
    defaultMessage:
      'Learn more about solar systems and photovoltaics here - practical tips on renting, buying and operating your own photovoltaic system.',
  },
  writtenByPrefix: {
    id: `${I18N_NAMESPACE}.writtenByPrefix`,
    defaultMessage: 'By',
  },
  postsByAuthor: {
    id: `${I18N_NAMESPACE}.postsByAuthor`,
    defaultMessage: 'Posts by',
  },
  blogListHeader: {
    id: `${I18N_NAMESPACE}.blogListHeader`,
    defaultMessage: 'Blog posts',
  },
  tableOfContentsHeader: {
    id: `${I18N_NAMESPACE}.tableOfContentsHeader`,
    defaultMessage: 'Table of Contents',
  },
});
